import createReactStore from 'zustand';
import { createCoreHooks, createProviderHooks } from './hooks';
import { queryContext } from './query';
export const createReactWallet = (coreWallet) => {
    const reactStore = createReactStore(coreWallet.getStore());
    let wallet = {
        ...coreWallet,
        getReactStore: () => reactStore,
        queryContext,
    };
    // create and merge builtin hooks to wallet
    wallet = [createCoreHooks, createProviderHooks].reduce((wallet, createHooks) => ({
        ...wallet,
        ...createHooks(wallet),
    }), wallet);
    const plugins = coreWallet.getPlugins();
    plugins.forEach((plugin) => {
        const pluginApi = plugin({ wallet });
        coreWallet.pluginApiMap.set(plugin.pluginName, pluginApi);
    });
    return wallet;
};
